import React, { Component } from 'react'
import './inventory.css'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { DataGrid } from '@mui/x-data-grid'
import { Trans, withTranslation } from 'react-i18next'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { DateTime } from 'luxon'
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack, Tooltip } from '@mui/material'
import DatePicker from '../../../Components/DatePicker/DatePicker'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonGridHeader from '../../../Components/Common Components/CommonComponents'
import NewDatePicker from '../../../Components/DatePicker/NewDatePicker'


class NoMovement extends Component {
  constructor(props) {
    super(props)
  }
  state = {
    pageSize: 10,
    noMovementList: [],
    datePickerPop: false,
    QueryFromDate: "",
    QueryToDate: "",
    dateFilter: 0,
    searchkey : '',
    disableBtn: false,
  }

  componentDidMount() {
    this.getNoMovementList()
  }

  componentWillReceiveProps(props){
    if(props.search_key != this.state.searchkey){
        this.setState({
            searchkey: props.search_key
        },() => {
            this.getNoMovementList()
        })
    }
  }

  msgClose(){
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      isSuccessMsg: false,
      isSuccessMsgText: "",
    })
}
 
LoaderFunction=(key)=>{
  this.setState({
    isLoader:key
  })
}
  getNoMovementList = () => {
    this.LoaderFunction(true)
    RestAPIService.getAll(Serviceurls.INVENTORY_NO_MOVEMENT_GET + "?from_date=" + this.state.QueryFromDate + "&to_date=" + this.state.QueryToDate +"&search_key=" + this.state.searchkey).
      then((response) => {
        if (response.data.status === "success") {
          this.setState({
            noMovementList: response.data.data
          },()=>{this.LoaderFunction(false)})
        }
      }).catch((error) => {
      this.LoaderFunction(false)  
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: error.response.data.message
      })})
  }

  CustomDates = (FromDate, ToDate) => {
    this.setState({
      QueryFromDate: FromDate,
      QueryToDate: ToDate,
      datePickerPop: false
    }, () => this.getNoMovementList())
  }
  PopClose = () => {
    this.setState({
      datePickerPop: false,
      QueryFromDate: "",
      QueryToDate: "",
      dateFilter: 0,
    })
  }

  handleDate = () => {
    var today = DateTime.now().toFormat('yyyy-MM-dd')
    var yesterday = DateTime.now().minus({ days: 1 }).toFormat('yyyy-MM-dd')
    var startweek = DateTime.now().minus({ days: 7 }).toFormat('yyyy-MM-dd')
    var startmonth = DateTime.now().minus({ days: 30 }).toFormat('yyyy-MM-dd')
    var startOfPreviousWeek = DateTime.now().minus({ weeks: 1 }).startOf('week').minus({ days: 1 }).toFormat('yyyy-MM-dd')
    var endOfPreviousWeek = DateTime.now().minus({ weeks: 1 }).endOf('week').minus({ days: 1 }).toFormat('yyyy-MM-dd')
    const startOfPreviousMonth = DateTime.now().minus({ month: 1 }).startOf('month').toFormat('yyyy-MM-dd');
    const endOfPreviousMonth = DateTime.now().minus({ month: 1 }).endOf('month').toFormat('yyyy-MM-dd');

    if (this.state.dateFilter === 0) {
      this.setState({
        QueryFromDate: "",
        QueryToDate: "",
      }, () => this.getNoMovementList())
    }
    else if (this.state.dateFilter === 1) {
      this.setState({
        QueryFromDate: today,
        QueryToDate: today,
      }, () => this.getNoMovementList()
      )

    }
    else if (this.state.dateFilter === 2) {
      this.setState({
        QueryFromDate: yesterday,
        QueryToDate: yesterday,
      }, () => this.getNoMovementList())
    }
    else if (this.state.dateFilter === 3) {
      this.setState({
        QueryFromDate: startOfPreviousWeek,
        QueryToDate: endOfPreviousWeek,
      }, () => this.getNoMovementList())
    }
    else if (this.state.dateFilter === 4) {
      this.setState({
        QueryFromDate: startOfPreviousMonth,
        QueryToDate: endOfPreviousMonth,
      }, () => this.getNoMovementList())
    }
    else if (this.state.dateFilter === 5) {
      this.setState({ datePickerPop: true })
    }
  }

  DateHelperText = () => {
    if (this.state.dateFilter === 0) {
      return ""
    }
    else if (this.state.dateFilter === 1) {
      return DateTime.now().toFormat('dd-MM-yyyy')
    }
    else if (this.state.dateFilter === 2) {
      return DateTime.now().minus({ days: 1 }).toFormat('dd-MM-yyyy')
    }
    else if (this.state.dateFilter === 3) {
      // return `${DateTime.now().minus({ days: 7 }).toFormat('dd-MM-yyyy')}  to  ${DateTime.now().minus({ days: 1 }).toFormat('dd-MM-yyyy')}`
      const startOfPreviousWeek = DateTime.now().minus({ weeks: 1 }).startOf('week');
      const endOfPreviousWeek = DateTime.now().minus({ weeks: 1 }).endOf('week');
       return `${startOfPreviousWeek.minus({ days: 1 }).toFormat('dd-MM-yyyy')} to ${endOfPreviousWeek.minus({ days: 1 }).toFormat('dd-MM-yyyy')}`
      
    }
    else if (this.state.dateFilter === 4) {
      // return `${DateTime.now().minus({ days: 30 }).toFormat('dd-MM-yyyy')}  to  ${DateTime.now().minus({ days: 1 }).toFormat('dd-MM-yyyy')}`
      const startOfPreviousMonth = DateTime.now().minus({ month: 1 }).startOf('month');
      const endOfPreviousMonth = DateTime.now().minus({ month: 1 }).endOf('month');
      return `${startOfPreviousMonth.toFormat('dd-MM-yyyy')} to ${endOfPreviousMonth.toFormat('dd-MM-yyyy')}`
     
    }
    else if (this.state.dateFilter === 5) {
      return `${this.state.QueryFromDate.split("-").reverse().join("-")}  to  ${this.state.QueryToDate.split("-").reverse().join("-")}`
    }
  }
  getNoMovInventoryexcel = () => {
    const {t} = this.props
    try {
      this.setState({disableBtn: true})
      RestAPIService.excelGet(Serviceurls.INVENTORY_NO_MOVEMENT_GET + "?export_type=excel" + "&from_date=" + this.state.QueryFromDate + "&to_date=" + this.state.QueryToDate +"&search_key=" + this.state.searchkey).
        then((response) => {
          if(response.data){
          var pom = document.createElement('a');
          var csvContent = response.data; //here we load our csv data 
    
          let filename = response.headers["content-disposition"].split("filename=")[1]
    
          var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
          var url = URL.createObjectURL(blob);
          pom.href = url;
          pom.setAttribute('download', filename ? filename : 'registry.xlsx');
          pom.click();
          this.setState({disableBtn: false})
          }
        }).catch((error) => {
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: error.response.data.message,
            disableBtn: false,
          })
        })
    } catch (error) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: t("PrintError"),
        disableBtn: false,
      })
    }
  }

  render() {
    const { t } = this.props
    this.state.noMovementList.forEach((element,index) => {element.sno = index + 1})
    const columns = [
      { field: 'sno', headerName: t("SNo"), sortable: false, flex: 0.111},
      { field: 'material_type', headerName: t('MaterialType'), sortable: false, flex: 0.111,
      renderCell:(params)=>(<div>{params?.row?.material_type?.length > 14 ? <Tooltip placement="top" title={params?.row?.material_type} arrow><div>{params?.row?.material_type}</div></Tooltip> : params?.row?.material_type ? params?.row?.material_type : "-"}</div>) },
      { field: 'brand_name', headerName: t('BrandName'), sortable: false, flex: 0.111 ,
      renderCell:(params)=>(<div>{params?.row?.brand_name?.length > 14 ? <Tooltip placement="top" title={params?.row?.brand_name} arrow><div>{params?.row?.brand_name}</div></Tooltip> : params?.row?.brand_name ? params?.row?.brand_name : "-"}</div>)},
      { field: 'product_name', headerName: t('ProductName'), sortable: false, flex: 0.111 ,
      renderCell:(params)=>(<div>{params?.row?.product_name?.length > 14 ? <Tooltip placement="top" title={params?.row?.product_name} arrow><div>{params?.row?.product_name}</div></Tooltip> : params?.row?.product_name ? params?.row?.product_name : "-"}</div>)},
      { field: 'product_type', headerName: t('ProductType'), sortable: false, flex: 0.111,
      renderCell:(params)=>(<div>{params?.row?.product_type?.length > 14 ? <Tooltip placement="top" title={params?.row?.product_type} arrow><div>{params?.row?.product_type}</div></Tooltip> : params?.row?.product_type ? params?.row?.product_type : "-"}</div>) },
      { field: 'batch_no', headerName: t('BatchNo'), sortable: false, flex: 0.111,
      renderCell:(params)=>(<div>{params?.row?.batch_no?.length > 14 ? <Tooltip placement="top" title={params?.row?.batch_no} arrow><div>{params?.row?.batch_no}</div></Tooltip> : params?.row?.batch_no ? params?.row?.batch_no : "-"}</div>) },
      { field: 'purchase_order_date', headerName: t('LastPurchaseDate'), sortable: false, flex: 0.111,headerAlign:"center",align:"center",
      renderCell:(params)=>(<div>{params?.row?.purchase_order_date?.length > 14 ? <Tooltip placement="top" title={params?.row?.purchase_order_date} arrow><div>{params?.row?.purchase_order_date}</div></Tooltip> : params?.row?.purchase_order_date ? params?.row?.purchase_order_date : "-"}</div>) },
      { field: 'last_bill_date', headerName: t('LastBillDate'), sortable: false, flex: 0.111,headerAlign:"center",align:"center",
      renderCell:(params)=>(<div>{params?.row?.last_bill_date?.length > 14 ? <Tooltip placement="top" title={params?.row?.last_bill_date} arrow><div>{params?.row?.last_bill_date}</div></Tooltip> : params?.row?.last_bill_date ? params?.row?.last_bill_date : "-"}</div>) },
      { field: 'no_movement_days', headerName: t('NoMovementDays'), sortable: false, flex: 0.111,
      renderCell:(params)=>(<div>{params?.row?.no_movement_days?.length > 14 ? <Tooltip placement="top" title={params?.row?.no_movement_days} arrow><div>{params?.row?.no_movement_days}</div></Tooltip> : params?.row?.no_movement_days ? params?.row?.no_movement_days : "-"}</div>) }
    ]
    return (
      <div className='mov_container_card'>
        <div className='mov_header_card'>
          <div className='eMed_date_picker'>
            <FormControl >
              <InputLabel>{t("SelectDate")}</InputLabel>
              <Select sx={{  height: '2.2vw', cursor: "pointer",marginRight:"1vw",width:"10vw"}}
                size='small'
                onChange={(event) => { this.setState({ dateFilter: event.target.value }, () => this.handleDate()) }}
                value={this.state.dateFilter}
                labelId="demo-simple-select-required-label"
                label={t("SelectDate")}
              >
                <MenuItem value={0}>{t("All")}</MenuItem>
                <MenuItem value={1}>{t("Today")}</MenuItem>
                <MenuItem value={2}>{t("Yesterday")}</MenuItem>
                <MenuItem value={3}>{t("Lastweek")}</MenuItem>
                <MenuItem value={4}>{t("LastMonth")}</MenuItem>
                <MenuItem value={5} onClick={() => { this.setState({ datePickerPop: true }) }} >{t("Custom")}</MenuItem>
              </Select>
              <FormHelperText id="eMed_form_helpertext">{this.DateHelperText()}</FormHelperText>
            </FormControl>
          </div>
          {this.state.datePickerPop ? <NewDatePicker PopClose={this.PopClose} CustomDates={this.CustomDates} /> : null}
          {/* <img className='mov_image_card' src={ImagePaths.LabPrintIcon.default} alt='print' /> */}
          <img className='eMed_upload' emed_tid='NoMovement_Export_Btn' src={ImagePaths.LabUploadButton.default} onClick={()=>{
            if(!this.state.disableBtn){
              this.getNoMovInventoryexcel()
            }}} alt='upload' />

        </div>
        <div className='mov_table_card'>
          <DataGrid
            rows={this.state.noMovementList}
            columns={columns}
            pageSize={this.state.pageSize}
            onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }) }}
            rowsPerPageOptions={[10, 20, 30]}
            getRowId={(row) => row.sno}
            loading={this.state.isLoader}
            pagination
            hideFooterSelectedRowCount
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: CommonGridHeader.CommonToolBar,
              NoRowsOverlay:()=>(
                <Stack height="100%" alignItems="center" justifyContent="center">
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
          />
        </div>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : this.state.isSuccessMsg ?
            <ToastMsg
              severity={'success'}
              msg={this.state.isSuccessMsgText}
              msgPop={this.msgClose.bind(this)}
            /> : null
        }
      </div>
    )
  }
}

export default withTranslation()(NoMovement)
